import { defineFcm } from '../shared/factory';

export const FCM_META_PIXEL_PPMU_PREDICTED_LTV = defineFcm('meta_pixel_ppmu_predicted_ltv')
	.asNumber()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { countries: true },
		context: 'Meta Pixel PPMU Subscribe event',
		description:
			'Predicted lifetime value (USD), from the Analytics Membership LTV model, used for the Meta Pixel Subscribe event predicted_ltv parameter. Configure per-country overrides in the admin console: US 121.99, CA 100.14, IT 97.03, FR 84.73, ES 81.19, BR 52.06. Leave unset for other countries (JP/MX/AU/GB are explicitly TBD upstream) — the tracking value is omitted entirely rather than sent as a fabricated 0.',
	});
